<template>
    <div id="contenedor-opciones-tool-bar">
        <v-tabs>
            <template
                v-for="(opcion, index) in opciones">
                <v-tab
                    :key="index"
                    :to="{ name: opcion.ruta }"
                    exact>
                    {{ opcion.nombre }}
                </v-tab>
            </template>
        </v-tabs>
    </div>
</template>

<script>
export default {
  name: 'OpcionesToolBar',
  data() {
    return {
      opciones: [
        {
          nombre: 'Generales',
          ruta: 'contrato',
          icono: '',
        },
        {
          nombre: 'Contrato Relacionados',
          ruta: 'contratoContratosRelacionados',
          icono: '',
        },
        {
          nombre: 'Anticipos',
          ruta: 'contratoAnticipos',
          icono: '',
        },
        {
          nombre: 'Convenios mod.',
          ruta: 'contratoConvenios',
          icono: '',
        },
        /*
        {
          nombre: 'Fianzas',
          ruta: 'contratoFianzas',
          icono: '',
        }, */
        {
          nombre: 'Catálogo',
          ruta: 'contratoCatalogo',
          icono: '',
        },
        {
          nombre: 'Deducciones',
          ruta: 'contratoDeducciones',
          icono: '',
        },
        {
          nombre: 'Programa',
          ruta: 'contratoPrograma',
          icono: '',
        },
        {
          nombre: 'Insumos',
          ruta: 'contratoInsumos',
          icono: '',
        },
        {
          nombre: 'Responsables',
          ruta: 'contratoResponsables',
          icono: '',
        },
        /*
        {
          nombre: 'Superintendente',
          ruta: 'contratoSuperintendentes',
          icono: '',
        }, */
        {
          nombre: 'Directorio',
          ruta: 'contratoDirectorio',
          icon: '',
        },
        {
          nombre: 'Pendientes',
          ruta: 'contratoActividades',
          icono: '',
        },
        {
          nombre: 'Expediente',
          ruta: 'contratoExpediente',
          icono: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
